document.addEventListener("DOMContentLoaded", function () {
  class YGDiscount extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init () {
      // 这里放置初始化逻辑
      this.clickCopy()
    }
    clickCopy () {
      // 这里放置自定义逻辑
      let $copyBtn = this.querySelector('.product-info__discount-button')
      let copyText = $copyBtn.getAttribute('data-code-text')
      let copyBtnText = $copyBtn.innerHTML
  
      $copyBtn.addEventListener('click', function () {
        navigator.clipboard.writeText(copyText).then(() => {
          $copyBtn.innerHTML = 'SUCCESS !'
          setTimeout(() => {
            $copyBtn.innerHTML = copyBtnText
          }, 3000)
        }, () => {
          $copyBtn.innerHTML = 'FAILURE !'
          setTimeout(() => {
            $copyBtn.innerHTML = copyBtnText
          }, 3000)
        });
      })
  
    }
  }
  if (!window.customElements.get('yg-discount')) {
    window.customElements.define('yg-discount', YGDiscount)
  }

  class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (e) => {
        this.closePopup(e, () => {});
      });
    }

    openPopup($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      this.querySelector('.yg-popup-box-content-inner').innerHTML = $popupTemplate.innerHTML;
      document.querySelector('body').style.overflow = 'hidden';
      this.style.display = 'flex';
      fn();
    }
    closePopup(e, fn) {
      if (e.target.className == 'yg-popup-box-close' || e.target.className == 'yg-popup-box') {
        this.style.display = 'none';
        this.querySelector('.yg-popup-box-content-inner').innerHTML = '';
        document.querySelector('body').style.overflow = 'auto';
        fn();
      }
    }
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.$popupBox = document.querySelector('.yg-popup-box');
    }
    init() {
      // 这里放置初始化逻辑
      this.addEventListener('click', this.itemClick.bind(this));
    }
    itemClick() {
      // 这里放置自定义逻辑
      let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');

      $popupTemplate && this.$popupBox.openPopup($popupTemplate, () => {});
      
    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }

  class YGProductList extends HTMLElement {
      constructor() {
          super()
          this.isDragging = false;
          this.startX = 0;
          this.initialScrollLeft = 0; // 初始滚动位置
          this._boundDragStart = this.dragStart.bind(this); // 绑定上下文
          this._boundDragMove = this.dragMove.bind(this);
          this._boundDragEnd = this.dragEnd.bind(this);
          this.init()
      }
      init() {
          // 这里放置初始化逻辑
          this.addEventListener('mousedown', this._boundDragStart);
          this.addEventListener('mousemove', this._boundDragMove);
          this.addEventListener('mouseup', this._boundDragEnd);
          this.addEventListener('mouseleave', this._boundDragEnd);
      }

      dragStart(e) {
        this.isDragging = true;
        this.startX = e.pageX - this.offsetLeft;
        this.initialScrollLeft = this.scrollLeft; // 保存初始滚动位置
        this.style.cursor = 'grabbing'; // 激活抓取状态
      }

      dragMove(e) {
        if (!this.isDragging) return;
        e.preventDefault();

        const x = e.pageX - this.offsetLeft;
        const walk = (x - this.startX) * 1; // 调整滚动速度的系数
        this.scrollLeft = this.initialScrollLeft - walk;
      }

      dragEnd(e) {
        this.isDragging = false;
        this.style.cursor = 'grab';
      }
  }
  if (!window.customElements.get('yg-product-list')) {
      window.customElements.define('yg-product-list', YGProductList)
  }
})
